/**
 * **同梱の画像を canvas で描くための読み込み**（Issue #552 → #565 で core へ）。
 * three は `kit.urlTexture` で読むが、盤の紙（`drawField`）・盤に置く印（`drawObjects`）は 2D canvas なので `Image` が要る。
 * **同じ URL なら同じ要素**（読み込みは 1 回）。読み終わる前は描かずに飛ばし、呼ぶ側は読み終わりを描き直しの鍵に入れる
 * （盤の紙はテーマの `images` をページが `preloadImages` で先に読み、`scene.imagesReady` で描き直す）。
 */
const cache = new Map();

/** URL → `Image`（最初に呼ばれたときに読み始める）。`Image` の無い環境では null */
export function themeImage(url) {
  if (!url || typeof Image === 'undefined') return null;
  let im = cache.get(url);
  if (!im) {
    im = new Image();
    im.decoding = 'async';
    im.src = url;
    cache.set(url, im);
  }
  return im;
}

/** 描ける状態か（`Image` は読み終わり、canvas・動画などはそのまま） */
export function imageReady(im) {
  if (!im) return false;
  if (im.complete === undefined) return true;
  return Boolean(im.complete) && (im.naturalWidth ?? 1) > 0;
}

/**
 * 画像を**まとめて先に読む**。全部が読み終わる（失敗も含めて片が付く）と解決する。
 * 失敗した画像は描かれないだけ（`imageReady` が false のまま）なので、ここでは例外にしない。
 * @param {readonly string[]} urls
 * @returns {Promise<void>}
 */
export function preloadImages(urls) {
  const list = (urls ?? []).map(themeImage).filter(Boolean);
  return Promise.all(list.map((im) => (im.complete ? Promise.resolve() : new Promise((resolve) => {
    const done = () => { im.removeEventListener?.('load', done); im.removeEventListener?.('error', done); resolve(); };
    im.addEventListener?.('load', done);
    im.addEventListener?.('error', done);
    // 足した直後に読み終わっていた場合
    if (im.complete) done();
  })))).then(() => undefined);
}
